/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TriggerSource = {
    Button: 'button',
    Weight: 'weight',
    Api: 'api',
} as const;
export type TriggerSource = typeof TriggerSource[keyof typeof TriggerSource];


export function instanceOfTriggerSource(value: any): boolean {
    for (const key in TriggerSource) {
        if (Object.prototype.hasOwnProperty.call(TriggerSource, key)) {
            if (TriggerSource[key as keyof typeof TriggerSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TriggerSourceFromJSON(json: any): TriggerSource {
    return TriggerSourceFromJSONTyped(json, false);
}

export function TriggerSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerSource {
    return json as TriggerSource;
}

export function TriggerSourceToJSON(value?: TriggerSource | null): any {
    return value as any;
}

export function TriggerSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): TriggerSource {
    return value as TriggerSource;
}

